import React from 'react'

import { useAverageEventsAmountByPeriod } from './_load/AverageEventsAmountByPeriodLoader'
import BarChart from '../../../../../packages/kiti-charts/components/charts/BarChart'

const Chart = ({ widget }) => {
  const data = useAverageEventsAmountByPeriod()

  const config = {
    data,
    autoFit: true,
    xField: 'percentage',
    yField: 'label',
    color: widget.data?.color
  }

  return <BarChart {...config} />
}

export default Chart
